import React from 'react';
import { InfoWindow, TrafficLayer, withGoogleMap, GoogleMap, Marker, Polyline } from "react-google-maps";
import moment from 'moment-timezone';
export const Map = withGoogleMap((props) => {
    let path;
    if (props.waypoints.length > 30) {
        path = props.waypoints.filter((item, index) => {
            return index % 3 === 0;
        }).map((item, idx) => {
            return { timestamp: item.timestamp, lat: item.position.lat, lng: item.position.lng, mapKey: item.timestamp + idx };
        });
    }
    else {
        path = props.waypoints.map((item, idx) => {
            return { timestamp: item.timestamp, lat: item.position.lat, lng: item.position.lng, mapKey: item.timestamp + idx };
        });
    }
    return (React.createElement(GoogleMap, { defaultZoom: 10, defaultCenter: props.center },
        React.createElement(TrafficLayer, { autoUpdate: true }),
        path.map((stop) => {
            return (React.createElement(Marker, { key: stop.mapKey, noRedraw: true, icon: { url: "/img/waypoint.png", scaledSize: new google.maps.Size(20, 20) }, onMouseOut: () => props.onMouseOut(), onMouseOver: () => props.onMouseOver(stop.timestamp), position: stop }, props.visibleMarker === stop.timestamp && React.createElement(InfoWindow, null,
                React.createElement("div", null, moment(stop.timestamp).calendar()))));
        }),
        React.createElement(Polyline, { path: path, geodesic: true, defaultVisible: true, visible: true, options: {
                strokeColor: '#25AA82',
                strokeWeight: 2,
            } }),
        props.markers));
});
